const Mission = () => {
    return (
        <section
            id="ourmission"
            className="md:flex md:px-20 md:py-16 px-4 py-10"
        >
            {/* LEFT */}
            <div id="leftmission" className="md:w-1/2">
                <p className="text-blue-700 font-semibold text-sm uppercase tracking-widest">
                    Mission
                </p>

                <p className="text-3xl md:text-4xl font-extrabold mt-2 text-[#292D34] tracking-wider">
                    Our Mission
                </p>

                <div className="border-2 border-blue-500 rounded-3xl w-20 mt-3"></div>

                <p className="mt-5 opacity-60 font-medium leading-relaxed">
                    At Wahni IT Solutions, we&apos;re more than just a
                    technology company. We&apos;re passionate engineers,
                    creative problem-solvers, and trusted partners, driven by a
                    singular mission: to empower businesses with the tools and
                    expertise they need to thrive in today&apos;s dynamic
                    digital landscape.
                </p>

                <p className="mt-4 opacity-60 font-medium leading-relaxed">
                    If you&apos;re a business looking to unlock your potential,
                    embrace the future, and make a positive impact, we invite
                    you to partner with Wahni IT Solutions. Together, let&apos;s
                    write a success story powered by technology, innovation, and
                    a shared vision of a brighter tomorrow.
                </p>
            </div>

            {/* RIGHT */}
            <div
                id="rightmission"
                className="md:w-1/2 flex items-center justify-center mt-8 md:mt-0 px-4"
            >
                <p className="p-6 bg-white shadow-xl hover:scale-105 transition duration-300 text-4xl md:text-5xl rounded-lg font-extrabold select-none text-center">
                    <span className="text-purple-500">
                        Save People’s <br /> time
                    </span>
                    <br />
                    by making <br />
                    the world <br />
                    more productive.
                </p>
            </div>
        </section>
    );
};

export default Mission;
